import React, { useState, useEffect } from 'react'
import axios from 'axios'
import Skeleton from '@mui/material/Skeleton'
import OrderCard from './OrderCard'
import Paginator from './Paginator'
import { useNavigate } from 'react-router-dom'

export const HistoryOrderComponent = () => {
  const [orderHistory, setOrderHistory] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    fetchOrderHistory(currentPage)
  }, [currentPage])

  const fetchOrderHistory = async page => {
    setLoading(true)
    try {
      const storedToken = localStorage.getItem('token')
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/loyalty/user-history/${page}`,
        { local_id: null },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${storedToken}`
          }
        }
      )
      setOrderHistory(response.data.data)
    } catch (error) {
      console.error('Error:', error)
    } finally {
      setLoading(false)
    }
  }

  const formatDate = timestamp => {
    const date = new Date(timestamp)
    return date.toLocaleString()
  }

  const handlePrevPage = () => {
    setCurrentPage(prev => (prev > 1 ? prev - 1 : 1))
  }

  const handleNextPage = () => {
    setCurrentPage(prev => prev + 1)
  }

  const handleLogout = () => {
    localStorage.removeItem('token')
    navigate('/')
  }

  return (
    <div style={{ padding: '0 5px', marginBottom: '120px' }}>
      <h1
        style={{
          textAlign: 'center',
          fontFamily: 'Poppins',
          fontSize: '28px',
          fontStyle: 'normal',
          fontWeight: 600,
          lineHeight: 'normal'
        }}
      >
        Historia zamówień
      </h1>
      <Paginator onPrev={handlePrevPage} onNext={handleNextPage} />

      <ul
        style={{
          listStyle: 'none',
          padding: 0,
          margin: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        {loading ? (
          Array.from({ length: 5 }).map((_, index) => (
            <p key={index}>
              <Skeleton sx={{ width: 367, height: 78 }} />
            </p>
          ))
        ) : Array.isArray(orderHistory) && orderHistory.length > 0 ? (
          orderHistory.map(order => (
            <li key={order.id} style={{ width: '100%', maxWidth: '367px' }}>
              <OrderCard order={order} formatDate={formatDate} />
            </li>
          ))
        ) : (
          <p
            style={{
              color: 'black',
              fontFamily: 'Poppins',
              fontSize: '18px',
              fontWeight: '600',
              textAlign: 'center',
              marginTop: '300px',
              marginRight: '35px',
              whiteSpace: 'nowrap'
            }}
          >
            Nie robiłeś jeszcze zamówień😊
          </p>
        )}
      </ul>
    </div>
  )
}

export default HistoryOrderComponent
